const actions = [
  {
      title: 'Identify the behaviour you would like to start or stop.',
      text: 'Take a minute to think about the behaviour you are trying to change. Try to be really specific, [e.g. \'I am going to take a multivitamin supplement every morning\'].',
  },
  {
      title: 'Think about what challenges you may face when making this change. Write each of these down.',
      text: 'Have a think about what problems you might face, or have faced in the past, that could make it a little more challenging. This could be anything from forgetfulness to peer pressure. Write each of these down.',
  },
  {
      title: 'Work through each of these challenges individually, thinking about the steps you can take to solve the problem.',
      text: 'Going through each challenge individually, create a \'mini\' plan of how you could try to solve it. Be as specific as you can, thinking carefully about the challenge itself and the scenarios in which you might experience them.',
  },
  {
      title: 'Keep these plans in a visible place, to remind you to use them.',
      text: 'Keep your plans somewhere you will see them often, to remind yourself that they are there to use when you need them. This could be somewhere physical, such as the fridge, or digital, such as your phone screensaver.',
  },
];

const tip = '"It\'s okay if you come across a problem you had not made a plan for. Try your best to overcome this challenge, and make a note of how you did it to help you next time. Keep your plans in one place to build your own unique behaviour change guide.';

// eslint-disable-next-line import/no-anonymous-default-export
export default { actions, tip };
